import colors from "./colors";

/** Maps colors.js to document CSS variables (single source for hex values). */
export function applyThemeVarsToDocument() {
  const map = {
    "--color-bg-primary": colors.bgPrimary,
    "--color-bg-card": colors.bgCard,
    "--color-bg-border": colors.bgBorder,
    "--color-accent-blue": colors.accentBlue,
    "--color-accent-cyan": colors.accentCyan,
    "--color-accent-orange": colors.accentOrange,
    "--color-status-green": colors.statusGreen,
    "--color-status-red": colors.statusRed,
    "--color-text-primary": colors.textPrimary,
    "--color-text-muted": colors.textMuted,
    "--color-text-hint": colors.textHint,
    "--gradient-hero": colors.gradientHero,
    "--gradient-card": colors.gradientCard,
    "--gradient-cyan": colors.gradientCyan,
  };
  const root = document.documentElement;
  Object.entries(map).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });
}
